<template>
    <div class="TTL-photos" :style="{width:option.width}">
        <div class="TTL-photos-infos default-photos" @click.stop="uploadimages" />
        <div class="TTL-photos-infos" v-for="(photo,index) in thumblist" :key="index">
            <el-image :src="option.type=='default' ? photo : photo.thumb" fit="cover" />
            <div class="TTL-photos-del" @click.stop="delPhotos(index)" />
            <div v-if="option.type=='select'" :class="photo.is_cover ? 'TTL-photos-select' : 'TTL-photos-select-no' " @click.stop="changecover(index)" />
        </div>
    </div>
    <systemphotos 
        v-model:isshow="isshow" 
        :issingle="true" 
        :phototype="option && option.phototype ? option.phototype : 'shop'"
        @finish="handleFinish"
    />
</template>

<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import systemphotos from '@/components/systemphotos/index';
export default {
  props: ['value','option'],
  components: {
        systemphotos,
  },
  data() {
      return {
          isshow:false,
          thumblist: this.value && this.value.length > 0 ? this.value : [],
          templist:[],
          fileobj:'',
          fileloading:false,
          option: {
              width: this.option && this.option.width ? this.option.width : '100%',
              type: this.option && this.option.type ? this.option.type : 'default',  // default-默认普通多选照片  select-带筛选项的多选照片
              phototype: this.option && this.option.phototype ? this.option.phototype : 'shop',
          },
      }
  },

  watch: {
      value(val) {
          this.thumblist=val && val.length > 0 ? val : [];
      },
  },

  mounted() {
      this.changePhotoShop(); //调整相册图片默认排序
  },

  methods: {


      uploadimages() {
          this.isshow = true;
      },

      handleFinish(val) {
          this.isshow = false;
          if(!val || val.type=='cannel') return false;
          var urls=val.data || [];
          for(var i=0;i < urls.length;i++) {
              this.option.type=='default' ?
              this.thumblist.push(urls[i]) :
              this.thumblist.push({thumb:urls[i],is_cover:false});
          }
          this.changePhotoShop();
          this.$emit('finish',{url:this.thumblist});
      },


      /** 执行上传文件操作 **/
      uploadfile() {

          //文件上传结束
          if(this.templist.length==0) {
              this.fileloading=false;
              clearInterval(this.fileobj); //关闭定时任务
              this.changePhotoShop(); //调整相册图片默认排序
              this.$emit('finish',{url:this.thumblist});
              return false;
          }

          if(this.fileloading) return false; //正在执行上传操作
          this.fileloading=true; //上锁，标记操作正在执行

          var file=this.templist[0]; //提取待上传的文件
          INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:'normal',File:file}).then((res) => {
                this.templist.splice(0,1);  //删除已上传的文件数据
                this.fileloading=false;  //开关释放                 
                if(res.status > 0) return false;
                //更新上传数据
                this.option.type=='default' ? 
                this.thumblist.push(process.env.VUE_APP_IMAGE_ADDRESS+res.data.url) :
                this.thumblist.push({thumb:process.env.VUE_APP_IMAGE_ADDRESS+res.data.url,is_cover:false});
          });
      },


      /** 删除图片信息 **/
      delPhotos(index) {
          this.thumblist.splice(index,1);
          this.changePhotoShop(); //调整相册图片默认排序
          this.$emit('finish',{url:this.thumblist});
      },    



      /** 修改宠物相册封面 **/
      changecover(index) {
          var photos=this.thumblist;
          for(var i in photos) index==i ? photos[i].is_cover=true : photos[i].is_cover=false;
          this.changePhotoShop();
          this.$emit('finish',{url:this.thumblist});
      },



      /** 修改相册图片排序，封面图片排第一位 **/
      changePhotoShop() {
          if(this.option.type=='default') return false;
          if(!this.thumblist || this.thumblist=='' || this.thumblist.length==0) return false;  

          var i=-1;
          var photos=this.thumblist;
          var photoinfo={};
          for(var ii in photos) photos[ii].is_cover ? i=ii : '';
          i==-1 ? i=0 : '';
          photoinfo=photos[i];
          photoinfo.is_cover=true; //设置默认的图片

          var data=[photoinfo];
          for(var ii in photos) i!=ii ? data.push({thumb:photos[ii].thumb,is_cover:false}) : '';   
          this.thumblist=data;
      },


  }

}
</script>

<style scoped>
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:15px;margin-bottom:15px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 75%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;display:inline-flex;justify-content: center;align-items: center;background-color: #666eeb;background-image:url(@/assets/icon/select-white.png);background-repeat: no-repeat;background-size:10px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);}
</style>